// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--AOUTb","title":"_93444fe79c--title--ishov"};